import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentConfiguration } from '../environment/services/environment.configuration';
import { BusinessEntityService } from './business-entity.service';

@Injectable({
  providedIn: 'root'
})
export class AcknowledgementService {
  apiBaseUrl = 'http://localhost:3000';
  apiVersion = 'api/v1';
  serviceUrl = this.apiBaseUrl;

  contentType =  'application/json' // Sonar fix
  
  // constructor(private readonly http:HttpClient) {
  constructor(private readonly http:HttpClient,private readonly environment: EnvironmentConfiguration,private readonly bservice:BusinessEntityService) {
    this.apiBaseUrl = this.environment['apiUrl'].acknowledgementUrl;
    this.serviceUrl = this.apiBaseUrl;
  }

  public getSupplierAcknowledgementReceipt(responseKey): Observable<any> {
    const header = {
      headers: new HttpHeaders({
        'Content-Type': this.contentType,
        'Authorization': `${this.bservice?.userToken}`
      })
    } 
    const url = `${this.serviceUrl+this.apiVersion}/getSupplierAcknowledgementReceipt?responseId=${responseKey}`;
    return this.http.get<any>(url, header);
  }

  public updateSupplierAcknowledgementReceipt(body): Observable<any> {
    const header = {
      headers: new HttpHeaders({
        'Content-Type': this.contentType,
        'Authorization': `${this.bservice?.userToken}`
      })
    } 
    const url = `${this.serviceUrl+this.apiVersion}/updateSupplierAcknowledgementReceipt`;
    return this.http.put<any>(url, body, header);
  }
}
